import { render, staticRenderFns } from "./admin-dashboard.vue?vue&type=template&id=43f410e0&scoped=true&"
import script from "./admin-dashboard.vue?vue&type=script&lang=js&"
export * from "./admin-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./admin-dashboard.vue?vue&type=style&index=0&id=43f410e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f410e0",
  null
  
)

export default component.exports